export default {
  "about.heroAlt": "Baja California Sur",
  "about.missionImageAlt": "Tourists enjoying Baja",
  "about.title": "About us",
  "about.subtitle": "Connecting travelers with authentic experiences in Baja California Sur",
  "about.missionTitle": "Our mission",
  "about.missionP1": "BajApp Xperiences was born from the love for our land and the desire to share its wonders with the world. We believe that the best travel experiences are those that connect you with local culture, nature and the people who make each destination unique.",
  "about.missionP2": "We work hand in hand with local providers — fishermen, artisans, chefs, guides — to offer authentic experiences that go beyond the typical tourist circuits. Every tour, every meal, every ride is an opportunity to discover the real Baja.",
  "about.statTours": "Experiences available",
  "about.statProviders": "Local providers",
  "about.statTravelers": "Happy travelers",
  "about.statDestinations": "Destinations",
  "about.valuesTitle": "Our values",
  "about.value1Title": "Passion for Baja",
  "about.value1Desc": "Every experience we offer is chosen with love for this land and its people.",
  "about.value2Title": "Trust and safety",
  "about.value2Desc": "We verify all providers and guarantee secure payments with Mercado Pago.",
  "about.value3Title": "Community",
  "about.value3Desc": "We support local economies by working directly with families and small businesses.",
  "about.value4Title": "Sustainability",
  "about.value4Desc": "We promote responsible tourism that respects the environment and marine life.",
  "about.teamTitle": "Meet the team",
  "about.ctaTitle": "Want to know more?",
  "about.ctaDesc": "Get in touch with us and we'll be happy to tell you more about BajApp Xperiences.",
  "about.ctaButton": "Contact us",

  "how.title": "How it works",
  "how.subtitle": "Booking your next adventure in Baja California Sur is easier than you think",
  "how.step1Title": "Search and compare",
  "how.step1Desc": "Explore hundreds of unique experiences in La Paz, Los Cabos and Cabo San Lucas. Filter by category, price, date and more.",
  "how.step1d1": "Browse tours, transport, lodging and gastronomic experiences",
  "how.step1d2": "Read real reviews from other travelers",
  "how.step1d3": "Compare prices and what's included in each experience",
  "how.step2Title": "Book in minutes",
  "how.step2Desc": "Choose your date, number of travelers and complete your booking with just a few clicks. No complicated forms.",
  "how.step2d1": "Select the perfect date and time for your group",
  "how.step2d2": "Enter your contact details securely",
  "how.step2d3": "Pay securely with Mercado Pago (cards, OXXO, SPEI)",
  "how.step3Title": "Enjoy the experience",
  "how.step3Desc": "Receive instant confirmation and all the details by email. Just show up and enjoy.",
  "how.step3d1": "Get instant confirmation and detailed instructions",
  "how.step3d2": "Receive reminders before your experience",
  "how.step3d3": "Enjoy your adventure and share your review afterward",
  "how.trust1Title": "Secure payments",
  "how.trust1Desc": "All transactions are processed through Mercado Pago with bank-grade encryption.",
  "how.trust2Title": "Free cancellation",
  "how.trust2Desc": "Cancel up to 24 hours before your experience for a full refund on most bookings.",
  "how.trust3Title": "24/7 support",
  "how.trust3Desc": "Our team is available via WhatsApp and email to help you with anything you need.",
  "how.faqTitle": "Common questions",
  "how.faq1Q": "How do I know my booking is confirmed?",
  "how.faq1A": "You will receive an instant confirmation email with all your booking details, including date, time, meeting point and provider contact.",
  "how.faq2Q": "Can I modify my reservation after booking?",
  "how.faq2A": "Yes, you can modify the date or number of travelers up to 48 hours before the experience, subject to availability.",
  "how.faq3Q": "What payment methods are accepted?",
  "how.faq3A": "We accept credit and debit cards, OXXO payments, SPEI transfers and Mercado Pago balance.",
  "how.faq4Q": "Do I need to print my booking?",
  "how.faq4A": "No, just show the digital confirmation on your phone. The provider will have your details as well.",
  "how.ctaButton": "Explore experiences",

  "provider.heroAlt": "Provider",
  "provider.testimonialAlt": "Provider",
  "provider.title": "Are you a tourism service provider?",
  "provider.subtitle": "Join the leading booking platform in Baja California Sur and reach thousands of travelers looking for authentic experiences",
  "provider.ctaButton": "Register as provider",
  "provider.statTravelers": "Travelers per year",
  "provider.statTours": "Active experiences",
  "provider.statRating": "Average rating",
  "provider.statCountries": "Countries of origin",
  "provider.benefitsTitle": "Why join BajApp Xperiences?",
  "provider.b1Title": "Reach more travelers",
  "provider.b1Desc": "Access thousands of domestic and international tourists actively looking for experiences in Baja.",
  "provider.b2Title": "Easy booking management",
  "provider.b2Desc": "Manage your calendar, bookings and availability from a simple and intuitive dashboard.",
  "provider.b3Title": "Secure payments",
  "provider.b3Desc": "Receive your payments directly to your bank account. No chasing clients for collections.",
  "provider.b4Title": "Analytics and insights",
  "provider.b4Desc": "Understand your sales, most popular dates, customer demographics and growth trends.",
  "provider.b5Title": "Dedicated support",
  "provider.b5Desc": "Our team is here to help you succeed — from onboarding to optimizing your listings.",
  "provider.b6Title": "Verified reviews",
  "provider.b6Desc": "Build trust with authentic reviews from real travelers who experienced your service.",
  "provider.stepsTitle": "How to start",
  "provider.s1Title": "Create your account",
  "provider.s1Desc": "Register as a provider and complete your business profile.",
  "provider.s2Title": "List your experiences",
  "provider.s2Desc": "Add photos, descriptions, pricing and availability for each service.",
  "provider.s3Title": "Get verified",
  "provider.s3Desc": "Our team reviews your profile to ensure quality and authenticity.",
  "provider.s4Title": "Start receiving bookings",
  "provider.s4Desc": "Travelers book directly and you receive notifications instantly.",
  "provider.testimonial": "Since joining BajApp Xperiences, my fishing charter bookings have tripled. The platform brings me clients from Mexico City, the US and even Europe. The payment system is reliable and the support team is amazing.",
  "provider.testimonialName": "Javier Morales",
  "provider.testimonialRole": "Captain, Baja Sport Fishing",
  "provider.bottomCtaTitle": "Ready to grow your business?",
  "provider.bottomCtaDesc": "Join hundreds of local providers already using BajApp Xperiences to reach more travelers.",
};